import useProfile from "api/UserResource/useProfile";
import useAuthStore from "store/authStore";
import UpdateInstitution from "./UpdateInstitution";
import CreateInstitution from "./CreateInstitution";
import { Role } from "utils/server-constants/roles";
import AccountPage from "../AccountPage";
import AccountLayout from "../AccountLayout";

const MyInstitution = () => {
	const { hasRoles } = useAuthStore();

	const { data: profile, isLoading: isLoadingProfile } = useProfile();
	const institution = profile?.data?.institutions?.[0];

	return (
		<AccountPage>
			<AccountLayout isLoading={isLoadingProfile} profile={profile?.data}>
				<div className="w-full min-w-0">
					{hasRoles([Role.Institution]) && institution ? (
						<UpdateInstitution
							institutionId={institution.id}
							name={institution.name}
							level={institution.level}
							address={institution.address}
							country={institution.country}
							province={institution.province}
							contactNumber={institution.contact_number}
						/>
					) : hasRoles([Role.Individual]) ? (
						<CreateInstitution />
					) : (
						<p className="text-sm leading-relaxed text-gray-600">
							Only an institution admin can update the institution profile. Contact your
							institution admin if it still needs to be completed.
						</p>
					)}
				</div>
			</AccountLayout>
		</AccountPage>
	);
};

export default MyInstitution;
